const restrictedCustomers = ['ship_only'];

function isRestrictedCustomer(value) {
  return restrictedCustomers.includes(value);
}

export { isRestrictedCustomer };
